import { render, staticRenderFns } from "./Kpi_component.vue?vue&type=template&id=07033de0&"
import script from "./Kpi_component.vue?vue&type=script&lang=js&"
export * from "./Kpi_component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports